import * as React from 'react';
import { useContext } from 'react';

import { DeviceInfoContext } from '@/contexts/device-info-context';

function MoneyMoveIcon(props) {
  const { isMobile } = useContext(DeviceInfoContext);
  return isMobile ? (
    <svg width={32} height={30} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect x={1.333} y={12.334} width={29.333} height={17.333} rx={4} fill='url(#prefix__paint0_linear_211_995)' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.666 17.353c0-.195.21-.353.47-.353h5.647c.26 0 .47.158.47.353v.706c0 .195-.21.353-.47.353h-5.646c-.26 0-.471-.158-.471-.353v-.706zm0 2.353c0-.195.21-.353.47-.353h5.647c.26 0 .47.158.47.353v.706c0 .195-.21.353-.47.353h-1.881v3.831c0 .223-.211.404-.471.404h-.941c-.26 0-.47-.18-.47-.404v-3.831h-1.883c-.26 0-.471-.158-.471-.353v-.706z'
        fill='#fff'
      />
      <g filter='url(#prefix__filter0_bi_211_995)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M6.92 14.837a.605.605 0 00.827 0l6.748-6.442c.368-.35.107-.95-.413-.95h-3.486V1.447c0-.614-.523-1.113-1.168-1.113H5.24c-.645 0-1.168.499-1.168 1.113v6H.585c-.52 0-.78.599-.413.95l6.748 6.44z'
          fill='#72BF44'
          fillOpacity={0.5}
        />
      </g>
      <g filter='url(#prefix__filter1_bi_211_995)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M25.08.497a.605.605 0 00-.827 0l-6.748 6.441c-.367.35-.107.95.413.95h3.486v6c0 .614.523 1.112 1.168 1.112h4.189c.645 0 1.168-.498 1.168-1.113v-6h3.486c.52 0 .78-.598.413-.949L25.08.497z'
          fill='#72BF44'
          fillOpacity={0.5}
        />
      </g>
      <defs>
        <filter
          id='prefix__filter0_bi_211_995'
          x={-4}
          y={-3.667}
          width={22.667}
          height={22.666}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation={2} />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_211_995' />
          <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_211_995' result='shape' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx={0.2} dy={0.1} />
          <feGaussianBlur stdDeviation={0.5} />
          <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
          <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
          <feBlend in2='shape' result='effect2_innerShadow_211_995' />
        </filter>
        <filter
          id='prefix__filter1_bi_211_995'
          x={13.333}
          y={-3.667}
          width={22.667}
          height={22.666}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation={2} />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_211_995' />
          <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_211_995' result='shape' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx={0.2} dy={0.1} />
          <feGaussianBlur stdDeviation={0.5} />
          <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
          <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
          <feBlend in2='shape' result='effect2_innerShadow_211_995' />
        </filter>
        <linearGradient
          id='prefix__paint0_linear_211_995'
          x1={1.333}
          y1={12.334}
          x2={26.291}
          y2={7.424}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4FB84E' />
          <stop offset={1} stopColor='#2A8640' />
        </linearGradient>
      </defs>
    </svg>
  ) : (
    <svg width={72} height={72} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect x={14} y={32} width={44} height={26} rx={4} fill='url(#prefix__paint0_linear_70_6787)' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M31 39.53c0-.293.316-.53.706-.53h8.47c.39 0 .706.237.706.53v1.058c0 .292-.316.53-.706.53h-8.47c-.39 0-.706-.238-.706-.53V39.53zm0 3.529c0-.292.316-.53.706-.53h4.942a.34.34 0 01.01 0h3.518c.39 0 .706.237.706.53v1.059c0 .292-.316.529-.706.529h-2.823v5.748c0 .334-.316.604-.706.604h-1.411c-.39 0-.706-.27-.706-.605v-5.747h-2.824c-.39 0-.706-.237-.706-.53V43.06z'
        fill='#fff'
      />
      <g filter='url(#prefix__filter0_bi_70_6787)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M22.38 35.755a.907.907 0 001.24 0l10.122-9.662c.551-.526.16-1.424-.62-1.424h-5.228v-9c0-.922-.785-1.669-1.752-1.669h-6.284c-.968 0-1.752.747-1.752 1.67v8.999h-5.228c-.78 0-1.171.898-.62 1.424l10.122 9.662z'
          fill='#72BF44'
          fillOpacity={0.5}
        />
      </g>
      <g filter='url(#prefix__filter1_bi_70_6787)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M49.62 14.245a.907.907 0 00-1.24 0l-10.122 9.662c-.551.526-.16 1.424.62 1.424h5.228v9c0 .922.785 1.669 1.752 1.669h6.284c.967 0 1.752-.747 1.752-1.67v-8.999h5.228c.78 0 1.171-.898.62-1.424L49.62 14.245z'
          fill='#72BF44'
          fillOpacity={0.5}
        />
      </g>
      <defs>
        <filter
          id='prefix__filter0_bi_70_6787'
          x={8}
          y={10}
          width={30}
          height={30}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation={2} />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_70_6787' />
          <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_70_6787' result='shape' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx={0.2} dy={0.1} />
          <feGaussianBlur stdDeviation={0.5} />
          <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
          <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
          <feBlend in2='shape' result='effect2_innerShadow_70_6787' />
        </filter>
        <filter
          id='prefix__filter1_bi_70_6787'
          x={34}
          y={10}
          width={30}
          height={30}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation={2} />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_70_6787' />
          <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_70_6787' result='shape' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx={0.2} dy={0.1} />
          <feGaussianBlur stdDeviation={0.5} />
          <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
          <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
          <feBlend in2='shape' result='effect2_innerShadow_70_6787' />
        </filter>
        <linearGradient
          id='prefix__paint0_linear_70_6787'
          x1={14}
          y1={32}
          x2={51.437}
          y2={24.636}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4FB84E' />
          <stop offset={1} stopColor='#2A8640' />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default MoneyMoveIcon;
